import {
  SCREENING_QUESTION_CODES,
  SCREENING_QUESTION_TYPES,
} from "../screeningQuestionsData";

export const listPastMedicationsQuestions = {
  [SCREENING_QUESTION_CODES.list_past_psych_medications]: {
    title:
      "Please list all the medications you have taken in the past as part of your psychiatric care.",
    type: SCREENING_QUESTION_TYPES.multi_medication_name,
  },
};
